import React from 'react';
import { Grid } from '@mui/material';
import minilogo from '../assets/javasite/images/minilogo.png';

export function NotFoundPage() {
  return (
    <Grid container justifyContent="center" spacing={1}>
      <Grid item>
        <div id="about1" className="isoitem about-tope">
          <div className="blackbox">
            <div id="minilogo"><img src={minilogo} width="196" height="158" alt="DraZtic Mini Logo" /></div>
            <div id="title4"><strong>DRAZTIC</strong></div>
            <div id="abouttext" flex="" className="flex">
              <p>404, Page Not Found!
                <br />
                The requested URL was not found.
              </p>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
